import React from 'react';
import { View, Text, StyleSheet, Platform, TouchableOpacity } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { TextInputContainer, Validate, YesNoToggle, DateTimePicker } from '../../components';
// import DateTimePicker from '@react-native-community/datetimepicker';
import moment from 'moment';

const Insurance = ({ navigation, ...props }) => {
  const [expiryMode, setExpiryMode] = React.useState('date');
  const [showDate, setShowDate] = React.useState(false);
  const [dateDisplay, setDateDisplay] = React.useState('');

  React.useEffect(() => {
    setShowDate(false);
  }, []);

  const onChangeInsuranceIssuer = (input) => {
    if (props.isInvalid.insuranceIssuer && Validate.Blank(input)) {
      props.setIsInvalid(prevState => { return { ...prevState, insuranceIssuer: false } });
    }
    props.setInsuranceIssuer(input);
  };
  const onChangeInsurancePolicy = (input) => {
    if (props.isInvalid.insurancePolicy && Validate.Blank(input)) {
      props.setIsInvalid(prevState => { return { ...prevState, insurancePolicy: false } });
    }
    props.setInsurancePolicy(input);
  };
  const onChangeInsuranceExpiry = (event, selectedDate) => {
    setShowDate(false);
    if(selectedDate === undefined){ return; }
    console.log('onChangeInsuranceExpiry', selectedDate, moment(selectedDate).format("YYYY-MM-DD"));
    // if (isInvalid.insuranceExpiry && Validate.Blank(input)) {
    //   setIsInvalid(prevState => { return { ...prevState, insuranceExpiry: false } });
    // }
    // props.setInsuranceExpiry(input);
    const currentDate = selectedDate || props.expiry;
    // setShowExpiry(Platform.OS === 'ios');
    props.setInsuranceExpiry(currentDate);
    setDateDisplay(moment(selectedDate).format("MMMM Do, YYYY"));
    props.setInsuranceExpiryChanged(true);
    
    // setExpiryDate(currentDate);
  };

  const onChangeDateWeb = (ev) => {
    console.log('onChange: ', ev.target.value);
    props.setInsuranceExpiry(ev.target.value);
    props.setInsuranceExpiryChanged(true);
  }

  const webDateInput = React.createElement('input', {
    type: 'date',
    value: props.insuranceExpiry,
    onChange: onChangeDateWeb,
    style: {
      borderColor: Colors.lightBlue,
      borderStyle: 'solid',
      borderWidth: 1,
      backgroundColor: Colors.textInputBackground,
      padding: 10,
      borderRadius: 10,
      color: Colors.lightText,
      fontSize: 18,
      marginBottom: 20,
    }
  })

  return (
    <>
      <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Insurance</Text>
      <YesNoToggle setValue={props.setInsurance} value={props.insurance} text='Do you have insurance?' />
      {props.insurance &&
        <>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Insurer Name</Text>
          <TextInputContainer
            placeholder='Name of your insurer'
            textContentType='none'
            onChangeText={(t) => onChangeInsuranceIssuer(t)}
            inputRef={props.textInputs.insuranceIssuer}
            isInvalid={props.isInvalid.insuranceIssuer}
            autoCapitalize='words'
            autoCompleteType='off'
            autoCorrect={false}
            returnKeyType='next'
            onSubmitEditing={() => props.textInputs.insurancePolicy.current.focus()}
            value={props.insuranceIssuer}
          />

          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Policy #</Text>
          <TextInputContainer
            placeholder='Your insurance policy number'
            textContentType='none'
            onChangeText={(t) => onChangeInsurancePolicy(t)}
            inputRef={props.textInputs.insurancePolicy}
            isInvalid={props.isInvalid.insurancePolicy}
            autoCapitalize='none'
            autoCompleteType='off'
            autoCorrect={false}
            keyboardType='number-pad'
            returnKeyType='next'
            onSubmitEditing={() => props.textInputs.insuranceExpiry.current.focus()}
            value={props.insurancePolicy}
          />
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Expiry Date</Text>
          {/* {showExpiry && ( */}
          {Platform.OS === 'ios' &&
            <View style={{ borderRadius: 10, overflow: 'hidden', marginBottom: 10, borderWidth: 1, borderColor: Colors.lightBlue }}>
              <DateTimePicker
                testID="dateTimePicker"
                value={props.insuranceExpiry}
                mode={expiryMode}
                is24Hour={false}
                onChange={onChangeInsuranceExpiry}
                minimumDate={new Date()}
                display="spinner"
                style={{ backgroundColor: Colors.textInputBackground, }}
                textColor={Colors.lightText}
              />
            </View>
          }
          {(Platform.OS === 'android') &&
          <TouchableOpacity onPress={() => { setShowDate(true) }} style={{ backgroundColor: 'yellow', borderRadius: 10, marginBottom: 10, }}>
            <TextInputContainer
              placeholder='Your insurance policy expiry date'
              textContentType='none'
              value={dateDisplay}
              editable={false}
              inputContainerStyle={{ marginBottom: 0 }}
            />
          </TouchableOpacity>
          }
          {((Platform.OS === 'android') && showDate) &&
            <DateTimePicker
              testID="dateTimePicker"
              value={props.insuranceExpiry}
              mode={expiryMode}
              is24Hour={false}
              onChange={onChangeInsuranceExpiry}
              minimumDate={new Date()}
              display="default"
              style={{ width: '100%', borderWidth: 1, borderColor: Colors.lightBlue, backgroundColor: Colors.textInputBackground, borderRadius: 10, height: 44, marginBottom: 10, Color: Colors.lightText }}
            />
          }
          {(Platform.OS === 'web') &&
            webDateInput
          }
        </>
      }
    </>
  )
}

const styles = StyleSheet.create({
  title: {
    marginVertical: 10,
  },
  inputLabel: {
    marginBottom: 7,
  },
});

export default Insurance;